export const HOME = {
  heroCta: "home-hero-cta",
  exploreLibrary: "home-explore-library",
  featuredReports: "home-featured-reports",
  insightSeries: "home-insight-series",
  pdfDownloads: "home-pdf-downloads",
};

export const NAV = {
  brand: "nav-brand",
  library: "nav-library",
  admin: "nav-admin",
  mobileToggle: "nav-mobile-toggle",
};

export const LIBRARY = {
  searchInput: "library-search-input",
  categorySelect: "library-category-select",
  resultsGrid: "library-results-grid",
  card: (slug) => `library-card-${slug}`,
};

export const REPORT = {
  container: "report-container",
  backLink: "report-back-link",
  toc: "report-toc",
  sources: "report-sources",
};

export const ADMIN = {
  loginUsername: "admin-login-username",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout",
  newReport: "admin-new-report",
  saveReport: "admin-save-report",
  deleteReport: (id) => `admin-delete-${id}`,
  editReport: (id) => `admin-edit-${id}`,
  regenerate: (id) => `admin-regenerate-${id}`,
  inquiriesTab: "admin-inquiries-tab",
  reportsTab: "admin-reports-tab",
  inquiryRow: (id) => `admin-inquiry-${id}`,
  inquiryStatus: (id) => `admin-inquiry-status-${id}`,
  inquiryDelete: (id) => `admin-inquiry-delete-${id}`,
};

export const INQUIRY = {
  form: "inquiry-form",
  name: "inquiry-name",
  email: "inquiry-email",
  company: "inquiry-company",
  message: "inquiry-message",
  submit: "inquiry-submit",
  success: "inquiry-success",
};
